/**
 * Data Explorer shell - routes the three browse views, each gated by
 * the same per-view access check DataHub applied
 * (`userCanAccessInspectorItem(role, 'data', id)`). The `App.tsx`
 * `FpUserGuard kind="page" id="data_explorer"` wrapper stays untouched
 * above this.
 */
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Alert, Box } from '@mui/material'
import { useAuth } from '../../../contexts/AuthContext'
import { userCanAccessInspectorItem } from '../../../config/fpUserAccess'
import DataExplorerRoute from './DataExplorerRoute'
import type { DataViewKey } from '../../../config/dataExplorer'

const DataExplorer: React.FC = () => {
  const { user } = useAuth()

  const guard = (id: DataViewKey, node: React.ReactNode) =>
    userCanAccessInspectorItem(user?.role, 'data', id) ? (
      node
    ) : (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">You don't have access to this data view.</Alert>
      </Box>
    )

  return (
    <Routes>
      <Route index element={<Navigate to="sales" replace />} />
      <Route path="sales" element={guard('sales', <DataExplorerRoute viewKey="sales" />)} />
      <Route path="products" element={guard('products', <DataExplorerRoute viewKey="products" />)} />
      <Route path="clients" element={guard('clients', <DataExplorerRoute viewKey="clients" />)} />
    </Routes>
  )
}

export default DataExplorer
